"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var events_1 = require("events");
var ProtocolHelper_1 = __importDefault(require("./ProtocolHelper"));
/**
 * Represents subscription to a topic. Allows to subscribe and unsubscribe from events and manage Subscription lifecycle
 */
var Subscription = /** @class */ (function () {
    function Subscription(routingKey, onCancelCallback) {
        if (onCancelCallback === void 0) { onCancelCallback = function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/, true];
        }); }); }; }
        var _this = this;
        this.routingKey = routingKey;
        this.onCancelCallback = onCancelCallback;
        /**
         * Subscribe on socket event. Events are mapped using routing key, and Rpc Notification method will represent
         * event name.
         */
        this.on = function (event, handler) {
            if (_this.canceled) {
                throw new Error('Cannot add event listener to canceled subscription');
            }
            _this.handlers.on(event, handler);
            return _this;
        };
        /**
         * Unsubscribe of socket event
         */
        this.off = function (event, handler) {
            if (_this.canceled) {
                throw new Error('Cannot remove listener from canceled subscription');
            }
            _this.handlers.off(event, handler);
            return _this;
        };
        /**
         * Get Routing Key
         *
         * @return {String}
         */
        this.getRoutingKey = function () { return _this.routingKey; };
        /**
         * Cancel subscription
         */
        this.cancel = function () {
            _this.canceled = true;
            return _this.onCancelCallback(_this.routingKey);
        };
        /**
         * Check if subscription canceled
         */
        this.isCanceled = function () { return _this.canceled; };
        this.handlers = new events_1.EventEmitter();
        this.canceled = false;
    }
    /**
     * Emit socket event
     *
     * @param {Notification|Object} notification Json Rpc 2.0 Notification
     */
    Subscription.prototype.emit = function (notification) {
        if (ProtocolHelper_1.default.getRoutingKey(notification) === this.routingKey) {
            var event_1 = notification.method;
            this.handlers.emit(event_1, notification, this);
        }
    };
    return Subscription;
}());
exports.default = Subscription;
//# sourceMappingURL=Subscription.js.map